import ErrorReporter from "@/services/ErrorReporter"
import {
  computed,
  isRef,
  toValue,
  unref,
  type MaybeRef,
  type MaybeRefOrGetter,
} from "vue"

const staleTimeInMs = 1000 * 60

export const useQueryOptions = <TOptions extends object>(
  options: TOptions,
  params: { [key: string]: MaybeRef },
): TOptions => {
  // Generated hooks pass their own `enabled` that treats 0 as a valid id, so combine rather than override.
  const { enabled } = options as { enabled?: MaybeRefOrGetter<boolean> }

  return {
    retry: false,
    staleTime: staleTimeInMs,
    throwOnError: (error: Error) => {
      ErrorReporter.report(error)
      return false
    },
    ...options,
    enabled: computed(
      () =>
        Object.values(params)
          .filter((param) => isRef(param))
          .every((v) => !!unref(v)) &&
        (toValue(enabled) ?? true),
    ),
  } as const
}
